import axios, { AxiosInstance } from 'axios';
import { jwtDecode } from 'jwt-decode';
import { useAuthStore } from '../store/useAuthStore';
import { useMessagesStore } from '../store/useMessagesStore';
import { apiRotateToken } from './auth-service';

const { addError } = useMessagesStore.getState();
const { logout, setAccessToken, setRefreshToken } = useAuthStore.getState()

const isTokenExpired = (token: string) => {
  try {
    const { exp } = jwtDecode(token);
    if (!exp) return true;
    return Date.now() > (exp - 10) * 1000;
  } catch (e) {
    return true;
  }
}

export const createAuthenticatedApi = (baseURL: string): AxiosInstance => {
  const api = axios.create({
    baseURL,
  });

  api.interceptors.request.use(
    async (config) => {
      const { accessToken } = useAuthStore.getState();
      if (accessToken) {
        let currentToken = accessToken
        if (isTokenExpired(currentToken)) {
          const res = await apiRotateToken();
          setAccessToken(res?.accessToken);
          setRefreshToken(res?.refreshToken);
          currentToken = res?.accessToken;
        }
        config.headers.Authorization = `Bearer ${currentToken}`;
      }
      return config;
    },
  );

  // api.interceptors.response.use(undefined,
  //   (error) => {
  //     if (error.response?.status === 401) {
  //       logout();
  //       window.location.pathname = '/login';
  //     }
  //     addError((error.response?.data as any)?.message || 'Unexpected server error')
  //     return Promise.reject(error);
  //   },
  // )

  return api;
};
